// action - state management
import { LOGIN, LOGOUT, REGISTER, SESSION_TIMEOUT, SETQRIMAGE, REQUIRESETPASSWORD } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    qrImage: null,
    tempId: null,
    tempSecret: null,
    otpSessionKey: null,
    keepLogin: null,
    loginType: '', // this will identify of what type of login type for user
    isSessionTimeout: false,
    isKeepMeLogin: false,
    groupId: null,
    deployments: [] // will use in the global deployment under group
};

// eslint-disable-next-line
const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user, deployments = [] } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                isSessionTimeout: false,
                user,
                deployments
            };
        }
        case 'LOGIN_REQUEST_SUCCESS': {
            const { user, otpCode, qrImage, isKeepMeLogin = false, groupId = null } = action.payload;
            return {
                ...state,
                isInitialized: true,
                user,
                otpCode,
                qrImage,
                isKeepMeLogin,
                groupId
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null,
                qrImage: null,
                tempId: null,
                tempSecret: null,
                isSessionTimeout: false
            };
        }

        case SETQRIMAGE: {
            return {
                ...state,
                qrImage: action.payload?.qrImage || null,
                tempId: action.payload.id,
                tempSecret: action.payload.tempSecret,
                initLogin: action.payload?.initLogin || false
            };
        }

        case SESSION_TIMEOUT: {
            const { isSessionTimeout } = action.payload;
            return {
                ...state,
                isInitialized: true,
                isSessionTimeout
            };
        }

        case REQUIRESETPASSWORD: {
            return {
                ...state,
                requireSetPassword: action.payload?.requireSetPassword || false
            };
        }

        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
